import Image from "next/image";
import checkIcon from "@/assets/checkedIcon.svg";
import unchkedIcon from "@/assets/unChekedIcon.svg";
import { cn } from "@/lib/cn";
import Input from "./ui/Input";
import Button from "@/components/ui/button";
import NumberInput from "./ui/number-input";
import { CiDeliveryTruck } from "react-icons/ci";
import Select from "./ui/select";
import { useContext, useState } from "react";
import { languageContext } from "@/contexts/language-context";
import { MdKeyboardDoubleArrowDown } from "react-icons/md";

import popcardStandard from "@/translation/order/popcardStandard";
import { motion } from "framer-motion";
interface fieldInterface {
  label: string;
  value: string | number | null;
  setValue: any;
  error: string;
  placeholder: any;
  type: string | undefined;
  options?: any[];
  values?: any[];
}

interface formProps {
  name: string;
  description: any;
  checked: string[];
  unchecked: string[];
  colors: {
    color: string;
    value: string;
    name?: { fr: string; ar: string; en: string };
  }[];
  currentPrice: number;
  oldPrice: number;
  className: string | undefined;
  fields: fieldInterface[] | any;
  setFields: any;
  onSubmit: any;
  whatsappMessage: boolean;
  isMetrics: boolean;
  soldeOut?: boolean;
  message?: string;
}

const bulletsVariations = {
  closed: {
    height: 0,
  },
  open: {
    height: "auto",
  },
};

const translation: any = {
  readMore: {
    fr: "Lire plus",
    en: "Read more",
    ar: "اقرأ المزيد",
  },
  readLess: {
    en: "Read less",
    fr: "Lire moins",
    ar: "اقرأ أقل",
  },
};
const SellsForm = ({
  name,
  description,
  checked,
  unchecked,
  colors = [],
  currentPrice = 0,
  oldPrice = 0,
  className = "",
  fields,
  setFields,
  onSubmit,
  whatsappMessage,
  isMetrics,
  soldeOut,
  message,
}: formProps) => {
  const { lang } = useContext<any>(languageContext);
  const [showBullets, setShowBullets] = useState(false);

  const multiProfilePrice =
    fields["multiprofile"]?.value === "multiprofil" ? 100 : 0;

  const currentPriceAfterMultiprofile = currentPrice + multiProfilePrice;
  const oldPriceAfterMultiprofile = oldPrice + multiProfilePrice;
  return (
    <div
      className={cn(
        "flex flex-col gap-4 bg-neutral-900 border border-white/10 bg-gradient-to-br from-black/5 to-black/50 rounded-xl px-8 py-8 shadow-md",
        lang === "ar" && "max-w-[90%]",
        className
      )}
      id="commander-form"
    >
      <h3 className="text-2xl sm:text-4xl font-semibold">{name[lang]}</h3>
      <p className="text-base sm:text-base text-light-gray mt-4">
        {description[lang]}
      </p>

      {/* List of checks  and unchecks*/}
      <motion.div
        style={{ overflowY: "hidden" }}
        variants={bulletsVariations}
        animate={showBullets ? "open" : "closed"}
      >
        <ul className="flex flex-col gap-4">
          {checked.map((c, i) => {
            return (
              <li key={c + i} className="flex items-center gap-4">
                <Image
                  src={checkIcon}
                  alt={"checked icon"}
                  className="w-4 h-4"
                />
                <div className="text-light-gray text-base sm:text-base">
                  {c[lang]}
                </div>
              </li>
            );
          })}

          {unchecked.map((c, i) => {
            return (
              <li key={c + i} className="flex items-center gap-4">
                <Image
                  src={unchkedIcon}
                  alt={"checked icon"}
                  className="w-4 h-4"
                />
                <div className="text-light-gray text-base sm:text-base">
                  {c[lang]}
                </div>
              </li>
            );
          })}
        </ul>
      </motion.div>
      <div className="flex justify-end">
        <button
          className="flex items-center"
          onClick={() => setShowBullets((prev) => !prev)}
        >
          {!showBullets
            ? translation.readMore[lang]
            : translation.readLess[lang]}{" "}
          <div className="animate-bounce-slow">
            <MdKeyboardDoubleArrowDown
              className={cn(showBullets ? "rotate-180" : "rotate-0")}
            />
          </div>
        </button>
      </div>
      {/* colors and price*/}
      {!isMetrics && (
        <>
          {/* IF ITEMS NOT SOLDE OUT*/}
          {!soldeOut && (
            <div className="flex justify-between sticky top-[70px] md:top-[85px] left-0 bg-neutral-900 z-50 w-full">
              <div className="flex flex-col gap-2">
                {!message && (
                  <>
                    <h3 className="text-xl sm:text-2xl mb-2">
                      {lang === "fr"
                        ? "Couleur de l'impression :"
                        : lang === "ar"
                        ? "لون الطباعة"
                        : "Print color:"}
                    </h3>
                    <div className="flex items-center gap-4">
                      {colors.map((color: any, i) => {
                        return (
                          <div
                            key={i}
                            className="flex items-center flex-col md:flex-row cursor-pointer"
                            onClick={() => {
                              setFields({
                                ...fields,
                                color: {
                                  value: color.value,
                                },
                              });
                            }}
                          >
                            <div
                              key={color.color}
                              className={cn(
                                "w-5 h-5 sm:w-7 sm:h-7 rounded-full outline outline-offset-1 outline-[1px] outline-transparent",
                                color.value ===
                                  (fields.color.value satisfies string)
                                  ? "outline-white"
                                  : ""
                              )}
                              style={{ background: color.color }}
                            ></div>
                            {color?.name && (
                              <p
                                className={`${
                                  lang === "fr" || lang === "en"
                                    ? "md:pl-2"
                                    : "md:pr-2"
                                }`}
                              >
                                {color.name[lang]}
                              </p>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </>
                )}
                {message && (
                  <div className="text-xl sm:text-3xl text-yellow-200 font-medium">
                    {message}
                  </div>
                )}
              </div>

              <div className="flex flex-col items-start leading-tight">
                <span className="text-xl sm:text-2xl font-semibold">
                  {" "}
                  {currentPriceAfterMultiprofile} {popcardStandard.mad[lang]}
                </span>
                <span className="text-lg sm:text-xl line-through">
                  {oldPriceAfterMultiprofile} {popcardStandard.mad[lang]}
                </span>
                <span className="text-red-500 text-sm sm:text-lg">
                  {Math.floor(
                    ((oldPriceAfterMultiprofile -
                      currentPriceAfterMultiprofile) /
                      oldPriceAfterMultiprofile) *
                      1.0 *
                      100
                  )}
                  %
                </span>
              </div>
            </div>
          )}

          {/* IF ITEMS SOLDE OUT*/}
          {soldeOut && (
            <div className="flex justify-between">
              <div className="flex flex-col gap-2">
                <h3 className="text-xl sm:text-4xl mb-2 text-red-500">
                  {lang === "fr" ? "En rupture de stock" : "غير متوفر"}
                </h3>
              </div>

              <div className="flex flex-col items-start leading-tight">
                <span className="text-xl sm:text-2xl font-semibold">
                  {" "}
                  {currentPriceAfterMultiprofile} {popcardStandard.mad[lang]}
                </span>
                <span className="text-lg sm:text-xl line-through">
                  {oldPriceAfterMultiprofile + multiProfilePrice}{" "}
                  {popcardStandard.mad[lang]}
                </span>
                <span className="text-red-500 text-sm sm:text-lg">
                  {Math.floor(
                    ((oldPriceAfterMultiprofile -
                      currentPriceAfterMultiprofile) /
                      oldPriceAfterMultiprofile) *
                      1.0 *
                      100
                  )}
                  %
                </span>
              </div>
            </div>
          )}
        </>
      )}

      {/* Qunatity message when dealing with popcard metrics*/}
      {isMetrics && (
        <div className="flex justify-start">
          <span className="text-lg text-left sm:text-xl font-semibold">
            {lang === "fr"
              ? "Demander ma démo !"
              : lang === "ar"
              ? "اطلب عرض تجريبي!"
              : "Request a demo!"}
          </span>
        </div>
      )}

      {/* LOGO WHATSAPP MESSAGE*/}
      {whatsappMessage && (
        <p className="text-light-gray underline -mt-4 leading-[150%] text-base sm:text-base">
          {lang === "fr"
            ? "Vous recevrez un message de notre part sur WhatsApp pour nous envoyer votre logo*"
            : lang === "ar"
            ? "ستتلقى رسالة منا على WhatsApp لإرسال شعاركم إلينا"
            : "You will receive a message from us on WhatsApp to send us your logo*"}
        </p>
      )}

      {!soldeOut && (
        <form className="flex flex-col gap-8" onSubmit={onSubmit}>
          {Object.keys(fields).map((key: any, index: number) => {
            const f = fields[key];
            if (key === "color") return;
            if (f.type === "select") {
              return (
                <Select
                  key={index}
                  label={f.label[lang]}
                  placeholder={f.placeholder[lang]}
                  setValue={(val: any) => {
                    const newFields = { ...fields };
                    newFields[key].value = val;
                    newFields[key].error = { fr: "", ar: "" };
                    setFields(newFields);
                  }}
                  value={f.value}
                  options={f.options.map((option: any) => {
                    if (typeof option !== "string") {
                      return option[lang];
                    }
                    return option;
                  })}
                  values={f.values}
                  error={f.error[lang]}
                />
              );
            }
            if (f.type === "increment") {
              return (
                <NumberInput
                  key={index}
                  name={key}
                  label={f.label[lang]}
                  value={f.value}
                  setValue={(val: any) => {
                    const newFields = { ...fields };
                    newFields[key].value = val > 0 ? val : 1;
                    newFields[key].error = { fr: "", ar: "" };
                    setFields(newFields);
                  }}
                  disabled={false}
                />
              );
            }
            return (
              <Input
                key={index}
                name={key}
                label={f.label[lang]}
                placeholder={f.placeholder[lang]}
                value={f.value}
                error={f.error[lang]}
                setValue={(val: any) => {
                  const newFields = { ...fields };
                  newFields[key].value = val;

                  newFields[key].error = { fr: "", ar: "" };
                  setFields(newFields);
                }}
                disabled={false}
              />
            );
          })}

          <Button
            type="submit"
            label={
              lang === "fr"
                ? "Confirmer"
                : lang === "ar"
                ? "تأكيد الطلب"
                : "Confirm"
            }
            onClick={undefined}
            className={
              "mt-4 text-sm bg-neutral-900 border border-neutral-200 text-white hover:text-neutral-900"
            }
            isLoading={false}
          />

          {/* {!isMetrics && (
            <div className="flex items-center justify-center gap-4 text-sm">
              <CiDeliveryTruck size={25} />{" "}
              <span>
                {lang === "fr"
                  ? "Livraison gratuite à partir de 500 Dhs d'achat."
                  : "التوصيل مجاني ابتداءً من 500 درهم من الشراء."}
              </span>
            </div>
          )} */}
        </form>
      )}
    </div>
  );
};

export default SellsForm;
